<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.0005 5.00098C22.0753 5.00098 27 9.92563 27 16.0005C27 22.0754 22.0753 27 16.0005 27C9.92563 27 5.00098 22.0753 5.00098 16.0005C5.00098 9.92563 9.92562 5.00098 16.0005 5.00098ZM25 16.0005C25 11.0302 20.9708 7.00098 16.0005 7.00098C11.0302 7.00098 7.00098 11.0302 7.00098 16.0005C7.00098 20.9708 11.0302 25 16.0005 25C20.9708 25 25 20.9708 25 16.0005ZM16.0003 14.5858L18.8285 11.7577L20.2427 13.1719L17.4146 16L20.2427 18.8281L18.8285 20.2423L16.0003 17.4142L13.1716 20.2429L11.7574 18.8287L14.5861 16L11.7574 13.1713L13.1716 11.7571L16.0003 14.5858Z"
        />
    </svg>
</template>
